export class DOMError extends Error {
	constructor(message: string) {
		const msg: string = `<DOMError> "${message}".`;
		super(message);
		this.name = 'DOM Error';
	}
}
